import React, { useState } from "react";
import axios from "axios";
import { apiurl } from "../config/config";

const LoginAccessComposer = ({ onClose,userObjIds }) => {
  const [userIds, setUserIds] = useState(userObjIds);
  const [userIdInput, setUserIdInput] = useState("");

  const [accessType, setAccessType] = useState("anywhere");
  const [allowedIPs, setAllowedIPs] = useState([]);
  const [ipInput, setIpInput] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= ADD USER ID ================= */
  const addUserId = () => {
    if (userIdInput && !userIds.includes(userIdInput)) {
      setUserIds([...userIds, userIdInput.trim()]);
      setUserIdInput("");
    }
  };

  /* ================= ADD IP ================= */
  const addIP = () => {
    if (ipInput && !allowedIPs.includes(ipInput)) {
      setAllowedIPs([...allowedIPs, ipInput.trim()]);
      setIpInput("");
    }
  };

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {
    if (!userIds.length) {
      alert("Add at least one User ID");
      return;
    }

    if (accessType === "ip_restricted" && allowedIPs.length === 0) {
      alert("Add at least one IP");
      return;
    }

    try {
      setLoading(true);

      await axios.post(`${apiurl}/api/user/login-access`, {
        userObjIds: userIds,
        accessType,
        allowedIPs,
      });

      alert("Login access updated successfully");
      onClose();
    } catch (err) {
      console.error(err);
      alert("Failed to update access");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white w-full max-w-lg rounded-xl p-6 shadow-xl">
        <h2 className="text-xl font-bold mb-4">Login Access Composer</h2>

        {/* USER IDS */}
        <label className="font-semibold">User IDs</label>
        <div className="flex gap-2 mt-1">
          <input
            value={userIdInput}
            onChange={(e) => setUserIdInput(e.target.value)}
            placeholder="Enter User ObjectId"
            className="border p-2 rounded w-full"
          />
          <button
            onClick={addUserId}
            className="bg-blue-600 text-white px-4 rounded"
          >
            Add
          </button>
        </div>

        <div className="flex flex-wrap gap-2 mt-2 h-28 overflow-scroll">
          {userIds.map((id) => (
            <span
              key={id}
              className="bg-gray-200 px-2 py-1 rounded text-sm"
            >
              {id}
            </span>
          ))}
        </div>

        {/* ACCESS TYPE */}
        <label className="font-semibold mt-4 block">Access Type</label>
        <select
          value={accessType}
          onChange={(e) => setAccessType(e.target.value)}
          className="border p-2 rounded w-full mt-1"
        >
          <option value="anywhere">Anywhere</option>
          <option value="ip_restricted">IP Restricted</option>
          <option value="blocked">Blocked</option>
        </select>

        {/* IP LIST */}
        {accessType === "ip_restricted" && (
          <>
            <label className="font-semibold mt-4 block">
              Allowed IPs
            </label>
            <div className="flex gap-2 mt-1">
              <input
                value={ipInput}
                onChange={(e) => setIpInput(e.target.value)}
                placeholder="Enter IP address"
                className="border p-2 rounded w-full"
              />
              <button
                onClick={addIP}
                className="bg-green-600 text-white px-4 rounded"
              >
                Add
              </button>
            </div>

            <div className="flex flex-wrap gap-2 mt-2">
              {allowedIPs.map((ip) => (
                <span
                  key={ip}
                  className="bg-green-100 px-2 py-1 rounded text-sm"
                >
                  {ip}
                </span>
              ))}
            </div>
          </>
        )}

        {/* ACTIONS */}
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded border"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-5 py-2 rounded bg-blue-600 text-white"
          >
            {loading ? "Saving..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginAccessComposer;